import { createSelector } from '@ngrx/store';

export const getCommunitiesState = createSelector(
    (state: any) => state.communities,
    (state: any) => state.get('list')
);

export const getCreateCommunityState = createSelector(
    (state: any) => state.communities,
    (state: any) => state.get('createCommunity')
);

export const getUpdateCommunityState = createSelector(
    (state: any) => state.communities,
    (state: any) => state.get('updateCommunity')
);
 